import findClosestFocusTarget from '@utilities/find-closest-focus-target';

class SkipLink {
  constructor(element) {
    this.element = element;

    this.bindEvents();
  }

  bindEvents() {
    this.element.addEventListener('click', () => this.gotoTarget());
  }

  gotoTarget() {
    const href = this.element.getAttribute('href').split('#');
    const id = href.length > 1 ? href[1] : false;

    if(!id) return;
    const targetEl = document.getElementById(id);

    if (!targetEl) return;
    const focusTarget = findClosestFocusTarget(targetEl);
    focusTarget.focus();
  }
}

export default SkipLink;
